import { jsx as l } from "react/jsx-runtime";
import { useState as m, useCallback as d, useEffect as u, createContext as f, useContext as i } from "react";
const s = f({
  zoomPercentage: 100,
  isRetina: !1
}), z = ({ children: e }) => {
  const [o, c] = m({
    zoomPercentage: 100,
    isRetina: !1
  }), n = d(() => {
    const t = window.devicePixelRatio, a = t >= 2;
    let r;
    a ? r = Math.round(t / 2 * 100) : r = Math.round(t * 100), c({
      zoomPercentage: r,
      isRetina: a
    });
  }, []);
  return u(() => {
    n(), window == null || window.addEventListener("resize", n);
    const t = window.matchMedia("(resolution: 1dppx)");
    return t == null || t.addEventListener("change", n), () => {
      window == null || window.removeEventListener("resize", n), t == null || t.removeEventListener("change", n);
    };
  }, [n]), /* @__PURE__ */ l(s.Provider, { value: o, children: e });
}, P = () => {
  const e = i(s);
  return e || {
    zoomPercentage: 100,
    isRetina: !1
  };
}, g = () => {
  let e = "default";
  const { zoomPercentage: o } = i(s);
  return o < 90 ? e = "small" : o < 110 ? e = "default" : o < 150 ? e = "medium" : o < 200 ? e = "large" : e = "max", e;
};
export {
  z as ScreenZoomProvider,
  g as useScreenSize,
  P as useScreenZoom
};
//# sourceMappingURL=index.es530.js.map
